// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../node_modules/rescript/lib/es6/list.js";
import * as $$Array from "../../../../../../node_modules/rescript/lib/es6/array.js";
import * as Belt_List from "../../../../../../node_modules/rescript/lib/es6/belt_List.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_format from "../../../../../../node_modules/rescript/lib/es6/caml_format.js";

function getPrimarySecondaryAddress(str) {
  var splitStr = str.split(",");
  var lastIndex = splitStr.length;
  var secondary = splitStr[lastIndex - 1 | 0];
  var primary = str.replace("," + secondary, "");
  return [
          primary,
          secondary
        ];
}

function getWayPointsAttributes(wayPointOne, wayPointTwo, wayPointThree) {
  var wayPointList_1 = {
    hd: wayPointTwo,
    tl: {
      hd: wayPointThree,
      tl: /* [] */0
    }
  };
  var wayPointList = {
    hd: wayPointOne,
    tl: wayPointList_1
  };
  var filteredList = List.filter(function (e) {
          return e.showForm;
        })(wayPointList);
  var optionalLatLng = List.map((function (e) {
          return e.address.latLng;
        }), filteredList);
  var filteredOptionalArray = Belt_List.toArray(Belt_List.keepMap(optionalLatLng, (function (e) {
              return e;
            })));
  return $$Array.mapi((function (i, e) {
                var match = List.nth(filteredList, i).address;
                var address2 = match.address2;
                var address1 = match.address1;
                var match$1 = getPrimarySecondaryAddress(address1);
                var tmp = address2 === "" ? undefined : address2;
                return {
                        lat: e.lat,
                        long: e.lng,
                        address: {
                          title: match$1[0],
                          subtitle: match$1[1]
                        },
                        doorstep_address: tmp,
                        address_components: address1.split(", "),
                        address_details: {
                          locality: undefined,
                          sub_locality: undefined
                        },
                        favorite_uuid: undefined,
                        contact: {
                          name: match.senderName,
                          number: match.senderNumber
                        }
                      };
              }), filteredOptionalArray);
}

function getData(pickupAddress, dropAddress, geo_region_id, vehicle, goods_type, customerInfo, wayPointOne, wayPointTwo, wayPointThree, parentOrderId, assign_driver_manually) {
  var pickupLatLng = Belt_Option.getWithDefault(pickupAddress.latLng, {
        lat: 0.0,
        lng: 0.0
      });
  var dropLatLng = Belt_Option.getWithDefault(dropAddress.latLng, {
        lat: 0.0,
        lng: 0.0
      });
  var match = getPrimarySecondaryAddress(pickupAddress.address1);
  var match$1 = getPrimarySecondaryAddress(dropAddress.address1);
  var match$2 = pickupAddress.address2;
  var tmp = match$2 === "" ? undefined : pickupAddress.address2;
  var match$3 = dropAddress.address2;
  var tmp$1 = match$3 === "" ? undefined : dropAddress.address2;
  return {
          mobile: customerInfo.mobile,
          order: {
            geo_region_id: geo_region_id,
            vehicle_id: vehicle.vehicle_id,
            from_address_lat: pickupLatLng.lat,
            from_address_long: pickupLatLng.lng,
            from_address_doorstep: tmp,
            to_address_lat: dropLatLng.lat,
            to_address_long: dropLatLng.lng,
            to_address_doorstep: tmp$1,
            from_address: {
              title: match[0],
              subtitle: match[1]
            },
            from_address_components: pickupAddress.address1.split(", "),
            to_address: {
              title: match$1[0],
              subtitle: match$1[1]
            },
            to_address_components: dropAddress.address1.split(", "),
            from_address_details: {
              locality: undefined,
              sub_locality: undefined
            },
            to_address_details: {
              locality: undefined,
              sub_locality: undefined
            },
            pickup_favorite_uuid: undefined,
            drop_off_favorite_uuid: undefined,
            coupon_code: undefined,
            goods_type_info: {
              business_types_id: Caml_format.caml_int_of_string(goods_type.value),
              business_type_description: goods_type.text,
              quantity_of_goods: "Loose"
            },
            pickup_name: pickupAddress.senderName,
            pickup_phone_number: pickupAddress.senderNumber,
            payment_mode: "cash",
            use_porter_credits: false,
            customer_location_lat: undefined,
            customer_location_long: undefined,
            try_book_till: true,
            pickup_in_mins: 10,
            receiver_name: dropAddress.senderName,
            receiver_mobile_number: dropAddress.senderNumber,
            fs_info: {
              fare_type: "on_demand",
              quotation_uuid: vehicle.quotation_uuid
            },
            waypoints_attributes: getWayPointsAttributes(wayPointOne, wayPointTwo, wayPointThree),
            value_added_services: [],
            business_order_info: undefined,
            rebooking_info: parentOrderId !== undefined ? ({
                  parent_order_id: parentOrderId.orderCRN
                }) : undefined,
            assign_manually: assign_driver_manually
          }
        };
}

export {
  getPrimarySecondaryAddress ,
  getWayPointsAttributes ,
  getData ,
  
}
/* No side effect */
